module.exports = __webpack_public_path__ + "static/media/socialMedia.abc0d586.jpg";